import { FunctionComponent, SVGProps } from 'react'

export const IconCheck: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    stroke="#161B37"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.875 3.62891L2.75 5.50391L7.125 1.12891"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
